<template>
  <div>
    <div class="hero section-type-c bground-config-clean position-relative" :style="{ backgroundImage: `url('${hero}')` }">
      <div class="personal-container advertisements">
          <div class="row section-type-c pt-5">
              <div class="col-12 presentation-inner-padding-top2">
                  <div>
                      <h1 class="text-light text-center mb-24">
                          Conoce nuestro blog
                      </h1>
                      <p class="text-light text-center mb-64">
                          Aquí encontrarás artículos, noticias y actualizaciones sobre los autos que deseas
                      </p>
                  </div>
              </div>
          </div>
      </div>
    </div>
    <div class="section-type-a pt-5 pb-5 presentation">
      <div class="personal-container">
        <div class="mt-5 mb-64">
          <h2 class="text-center text-light">Noviembre 2020</h2>
          <!-- <h5 class="text-center text-light">Lorem ipsum dolor sit amet consectetur adipisicing elit.</h5> -->
        </div>
        <div class="row justify-content-center no-gutters p-3">
            <div class="col-12 col-md-8 col-lg-10">
                <div class="row section-type-c mb-32">
                  <BlogEntrance></BlogEntrance>
                  <BlogEntrance></BlogEntrance>
                  <BlogEntrance></BlogEntrance>
                  <BlogEntrance></BlogEntrance>
                  <BlogEntrance></BlogEntrance>
                  <BlogEntrance></BlogEntrance>
                  <BlogEntrance></BlogEntrance>
                  <BlogEntrance></BlogEntrance>
                  <BlogEntrance></BlogEntrance>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-around">
              <button type="button" class="btn btn-outline-warning d-block" style="border-radius: 0px;">Artículos anteriores</button>
              <button type="button" class="btn btn-outline-warning d-block" style="border-radius: 0px;">Artículos siguientes</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogEntrance from '@/components/BlogEntrance'
export default {
  name: 'Blog',
  components: {
    BlogEntrance
  },
  data () {
    return {
      hero: require('@/assets/images/blog.jpg')
    }
  }
}
</script>

<style scoped>

</style>
